import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
var ExerciseBookComponent = (function () {
    function ExerciseBookComponent(route, router, el, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.el = el;
        this.apiService = apiService;
        this.commonService = commonService;
        this.isCamp = false; //是否训练营
        this.isOpenClass = 0; //是否公开课
        this.isShowFilter = false; //是否显示筛选
        this.conditionFilter = { 'id': 0, 'status': 0, 'courseIndex': 0, 'statusIndex': 0 }; //默认筛选条件
    }
    ExerciseBookComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        $('#userIdContainer').val(localStorage.getItem('userId'));
        this.getUserCampAPI().then(function (result) {
            _this.camp = result;
        });
        this.getUserExerciseBookAPI(0, 0).then(function (result) {
            _this.exerciseBook = result;
        });
    };
    ExerciseBookComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'rgba(40,51,130,1)'
        });
        $('body').css("height", "auto");
    };
    //格式化状态，将数字状态格式化成文字
    ExerciseBookComponent.prototype.formatExerciseStatus = function (status) {
        return (status < 0 && '未开放') || (status < 20 && status >= 0 && '未提交') || (status < 30 && status >= 20 && '已提交') || (status < 40 && status >= 30 && '已点评') || '错误状态';
    };
    //格式化筛选标题
    ExerciseBookComponent.prototype.formatFilterTitle = function (params, type) {
        return type === '状态' ? { 0: '全部', 1: '未开放', 2: '未提交', 3: '已提交', 4: '已点评' }[params] || '全部状态' : type === '课程' ? this.camp[this.conditionFilter.courseIndex - 1]['name'] || '全部课程' : '';
    };
    //获取当前用户所有的训练营
    ExerciseBookComponent.prototype.getUserCampAPI = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/list'
        }).toPromise();
    };
    //获取用户所有训练营下面的练习册
    ExerciseBookComponent.prototype.getUserExerciseBookAPI = function (campId, status) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/applicationPractice/exerciseBook?campMetasId=' + campId + '&status=' + status
        }).toPromise();
    };
    //筛选功能
    ExerciseBookComponent.prototype.checkFilter = function (condition) {
        this.condition = condition;
        this.isShowFilter = true;
    };
    //关闭筛选
    ExerciseBookComponent.prototype.closeFilter = function () {
        this.isShowFilter = false;
    };
    //获取筛选条件并查询
    ExerciseBookComponent.prototype.getConditionAndSearch = function (event) {
        var _this = this;
        this.conditionFilter = event;
        this.getUserExerciseBookAPI(event['id'], event['status']).then(function (result) {
            _this.exerciseBook = result;
        });
    };
    /**
     * 进入详细的练习
     * @param item: Object  试卷对象
     */
    ExerciseBookComponent.prototype.goDetailWork = function (item) {
        if (item['status'] === -1) {
            return;
        }
        else if (item['status'] >= 20) {
            this.router.navigate(['learning-camp-response'], { queryParams: { 'constituteId': item['constituteId'], 'tabNum': 0 } }).then();
        }
        else {
            this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': item['learningPathMetasId'], 'module': '作业', 'btnName': '点击作业试卷', 'courseUnit': item['constituteId'], 'type': 0 }).then();
            this.router.navigate(['exercise-work', item['constituteId'], item['learningPathMetasId']]).then();
        }
        // this.router.navigate(['exercise-work', lpmapcId]).then();
    };
    //返回
    ExerciseBookComponent.prototype.exit = function () {
        this.router.navigate(['learning-map']);
    };
    return ExerciseBookComponent;
}());
export { ExerciseBookComponent };



// WEBPACK FOOTER //
// ./src/app/app-exercrise-book/exercise-book.component.ts.pre-build-optimizer.js